<script>
  export let name = ""
</script>

<label for="{name}">
  <slot/>
</label>

<style>
  label {
    position: relative;
    display: block;
    margin-bottom: 0.75rem;
    font-weight: 500;
    white-space: nowrap;
  }
</style>